import { RESET_FEATURE_FLAGS, SET_FEATURE_FLAGS } from './types';
export var setFeatureFlags = function setFeatureFlags(enabledFeatures) {
  return {
    type: SET_FEATURE_FLAGS,
    payload: enabledFeatures
  };
};
export var resetFeatureFlags = function resetFeatureFlags() {
  return {
    type: RESET_FEATURE_FLAGS
  };
};